import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

function authHeaders() {
  const token = localStorage.getItem("authToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function normalizeTime(value) {
  if (!value) return "";
  return String(value).slice(0, 5);
}

function logAxiosError(label, err) {
  console.error(label, err);
  if (err?.response) {
    console.error(`${label} response status:`, err.response.status);
    console.error(`${label} response data:`, err.response.data);
  }
}

// ---------------- Vaccine Reminder Settings ----------------

export async function getVaccineReminderSettings() {
  try {
    const res = await axios.get(`${BASE_URL}/api/public/vaccine-reminders/settings`, {
      headers: authHeaders(),
    });
    return res.data;
  } catch (err) {
    logAxiosError("getVaccineReminderSettings error", err);
    throw err;
  }
}

export async function saveVaccineReminderSettings(payload = {}) {
  const body = {
    enabled: payload.enabled ?? true,
    time: normalizeTime(payload.time || "09:00"),
    frontendBaseUrl: payload.frontendBaseUrl || window.location.origin,
    extraRecipients: payload.extraRecipients || "",
  };

  try {
    const res = await axios.put(
      `${BASE_URL}/api/public/vaccine-reminders/settings`,
      body,
      {
        headers: {
          ...authHeaders(),
          "Content-Type": "application/json",
        },
      }
    );
    return res.data;
  } catch (err) {
    logAxiosError("saveVaccineReminderSettings error", err);
    throw err;
  }
}

// ---------------- Manual reminder trigger ----------------

export async function sendTodayVaccineReminders(forceResend = false) {
  try {
    const res = await axios.post(
      `${BASE_URL}/api/public/vaccine-reminders/send-today`,
      null,
      {
        params: { forceResend },
        headers: authHeaders(),
      }
    );
    return res.data;
  } catch (err) {
    logAxiosError("sendTodayVaccineReminders error", err);
    throw err;
  }
}

const emailReminderService = {
  getVaccineReminderSettings,
  saveVaccineReminderSettings,
  sendTodayVaccineReminders,
};

export default emailReminderService;